import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subject, takeUntil } from 'rxjs';
import { FormBuilderService } from '../../../core/services/form-builder.service';

@Component({
  selector: 'irembogov-formly-field-stepper-section',
  templateUrl: './formly-field-stepper-section.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class FormlyFieldStepperSectionComponent
  extends FieldType
  implements OnInit, OnDestroy
{
  reviewModeEnabled = false;
  reviewModeEnabledSubControl$: Subject<void> = new Subject<void>();

  constructor(private readonly formBuilderService: FormBuilderService) {
    super();
  }

  ngOnInit(): void {
    this.formBuilderService.reviewModeEnabled$
      .pipe(takeUntil(this.reviewModeEnabledSubControl$))
      .subscribe((enabled: boolean) => (this.reviewModeEnabled = enabled));
  }

  ngOnDestroy(): void {
    this.reviewModeEnabledSubControl$.next();
    this.reviewModeEnabledSubControl$.complete();
  }
}
